export default "__VITE_ASSET__CJpPBXLY__"